module.exports = __webpack_public_path__ + "static/5-90b306f996ae3e3868b83018cbf22cb1.jpg";